import { rem, transparentize } from 'polished'
import React from 'react'
import styled from 'styled-components'
import type { PaddingProps } from 'styled-system'
import { Box } from 'components/Layout'
import { LOADER_SIZE } from 'components/Loader'
import { WrappedLoader } from 'components/WrappedLoader'
import { SPACE, COLOR } from 'Theme'

const MOBILE_MARGIN_BOTTOM = rem(50)

const ContentBox = styled(Box)`
  ${({ flex }) => flex && `flex: ${flex}`}
`

interface ContentProps extends PaddingProps {
  isLoading?: boolean
  isPaddingDisabled?: boolean
}

export const Content: React.FC<React.PWC<ContentProps>> = ({
  children,
  isLoading,
  isPaddingDisabled = false,
  ...props
}) => (
  <ContentBox
    mb={{ MOBILE: MOBILE_MARGIN_BOTTOM, TABLET: 0 }}
    p={{
      MOBILE: isPaddingDisabled ? 0 : SPACE.PX_20,
      TABLET: isPaddingDisabled ? 0 : `${SPACE.PX_40} ${SPACE.PX_30}`,
    }}
    position="relative"
    {...props}
  >
    {isLoading && (
      <WrappedLoader
        isOverlay
        paddingTop="25vh"
        justifyContent="start"
        onClick={(event) => {
          event.stopPropagation()
        }}
        background={transparentize(0.75, COLOR.GRAYSCALE_4)}
        loaderSize={LOADER_SIZE.XXXL}
      />
    )}
    {children}
  </ContentBox>
)
